import {Card, CardContent, Typography} from "@mui/material";
import React from "react";

const TextCard = ({content}) => {
    return (
        <Card className="custom-card">
            <CardContent>
                <Typography variant="h7" className="gray-text" gutterBottom>
                    {content}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default TextCard;